import React from 'react';
import { useMessage } from '@messageformat/react';
import { IconNotification } from '@op/opds.opux-icons/indicator';

const DisclaimerBox: React.FC = () => {
  const disclaimerTexts = useMessage('linkBoxDisclaimer');
  return (
    <div className="opux-v6__opds">
      <div className="align-center">
        <IconNotification size="large" />
      </div>
      {Object.entries(disclaimerTexts).map(([key, value]) => {
        const messageFunc = value as () => string;
        return (
          <p key={key} className="opds-styles-v1-text-body-xs">
            {messageFunc()}
          </p>
        );
      })}
    </div>
  );
};

export default DisclaimerBox;
